import { ApiSimpleTenant } from "@incendium/api";
import { listSamlTenants } from "features/sso/samlService";
import { useGlobalSharedState } from "./useSharedState";

export const useSamlTenants = () => {
  const fetchTenants = async () => {
    const res = await listSamlTenants();
    return res?.tenants || [];
  };

  const { state, setState, refetch, loading } =
    useGlobalSharedState<ApiSimpleTenant[]>(
    "samlTenants",
    [],
    fetchTenants,
  );

  return {
    tenants: state,
    setTenants: setState,
    refetchTenants: refetch,
    loading,
  };
};
